import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    credentials: {},
    signedIn: false,
    pathName:"",
    profileExists: false,
    profile: {},
    API_URL: {
      development: "http://localhost:6080",
      test: "https://api-test-ecs.uniqin.ai",
      production: "https://api-prod-ecs.uniqin.ai",
    },
    APP_URL: {
      development: "http://localhost:8080",
      test: "https://app-test.uniqin.ai",
      production: "https://app.uniqin.ai",
    },
    PUBLIC_SIGNUP_API: {
      development: "https://awsapi-dev.uniqin.ai",
      test: "https://awsapi-dev.uniqin.ai",
      production: "https://awsapi-prod.uniqin.ai",
    },
    ENDPOINT_URL: "https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.302c4cf3bec148fe89b9c584997ca73f&scope=advertising::campaign_management&response_type=code",
    forgot_password_email:""
    
  },
  mutations: {
    setProfile(state, payload){
      delete(payload.DeletedAt)
      state.profile = payload
    },
    setProfileExists(state, payload){
      state.profileExists = payload
    },
    setCredentials(state, payload){
      state.credentials = payload
    },
    setSignedIn(state, payload){
      state.signedIn = payload
    },
    setPathName(state, payload){
      state.pathName = payload
    },
    setForgotPasswordEmail(state, payload){
      state.forgot_password_email = payload
    },
   
  },
  actions: {
    setProfile(context, payload){
      context.commit('setProfile', payload)
    },
    setProfileExists(context, payload){
      context.commit('setProfileExists', payload)
    },
    setCredentials(context, payload){
      context.commit('setCredentials', payload)
    },
    setSignedIn(context, payload){
      context.commit('setSignedIn', payload)
    },
    setPathName(context, payload){
      context.commit('setPathName', payload)
    },
    setForgotPasswordEmail(context, payload){
      context.commit('setForgotPasswordEmail', payload)
    },
    
  },
  modules: {
  }
})
